// export const FULLNAME_PATTERN = /^([a-zA-Z'-]+[,.]?[ ]?|[a-zA-Z'-][^\u0000-\u007F]+['-]?)+$/i;
export const FULLNAME_PATTERN = /^\s?([a-zA-Z'-]+[,.]?[ ]+)+[a-zA-Z'-]{1,}\s?$/i;

export const SKU_PATTERN = /^\d{1,6}(?:[- ][0-9a-zA-Z]{0,4})*$/i; // pattern 123, 1234-, 123456-U, 123456-UD19-2L

